<div class="promostacks-banner">
	<div class="row">
		<img src="../../../assets/img/promo-stacks-modal/promo-stacks-logo.svg" class="promo-stacks-logo" alt="">
		<div class="promostacks-banner-content">
			<h4 class="title">A New Way to Book Promos</h4>
			<p class="description">Schedule an entire promo stack at once! Choose from our ready-made stacks to boost your book sales, save time, and make the Amazon algorithm work for you. Click below to view available promo stacks!</p>
			<button class="button regular solid-white cta" (click)="promosStacks()">Get Started</button>
		</div>
	</div>
</div>
